/** Union actual played intervals, bounded to one media version's duration. */
export function mergePlayedRanges(ranges: [number, number][], duration: number): [number, number][] {
  if (!Number.isFinite(duration) || duration <= 0) return [];
  const sorted = ranges.filter(([start, end]) => Number.isFinite(start) && Number.isFinite(end) && start >= 0 && end > start && start < duration)
    .map(([start, end]): [number, number] => [start, Math.min(end, duration)]).sort((a, b) => a[0] - b[0]);
  const merged: [number, number][] = [];
  for (const range of sorted) {
    const last = merged[merged.length - 1];
    if (last && range[0] <= last[1]) last[1] = Math.max(last[1], range[1]);
    else merged.push([...range]);
  }
  return merged;
}
